import { fileApi } from 'yxt-biz-pc/packages/api';

// 获取水印配置信息
export const getWatermarkSettings = () => {
  return fileApi.get(`newWatermark/config?orgId=${localStorage.orgId}`, {
    fullResponse: true
  });
};

// 获取水印配置
export const getWatermarkConfig = () => {
  return fileApi.get(`watermark/config?orgId=${localStorage.orgId}`, {
    fullResponse: true
  });
};
